<template>
    <div class="tm-item-card-shop" uk-grid>

        <!--
                &lt;!&ndash; Prices &ndash;&gt;

                &lt;!&ndash; Request &ndash;&gt;
                <div class="tm-item-card-shop-add">
                    <a class="uk-icon-button uk-icon uk-button-secondary"
                       href="#request"
                       uk-icon="icon: cart"
                       uk-toggle></a>
                </div>
        -->


        <div class="uk-width-1-1 tm-prices uk-text-small uk-margin-xsmall-top@s">
            <div class="tm-item-card-shop-prices">
                <div v-for="ProductPrice in ShopItemPrices" :class="[ProductPrice.ShopItemPrice.parent_id !== 0 ? 'uk-margin-top uk-margin-xsmall-top@s' : '']">

                <span v-if="ProductPrice.ShopItemPrice.parent_id === 0"
                      class="tm-item-card-price uk-margin-small-right">
                    {{ ProductPrice.ShopItemPrice.calculated_price }}&nbsp;{{ ProductPrice.ShopCurrency.name }}
                    <span v-if="ProductPrice.ShopItemPriceType.description"
                          :title="ProductPrice.ShopItemPriceType.description"
                          uk-icon="icon: question"
                          class="uk-icon tm-item-card-price-icon"
                          uk-tooltip></span>
                </span>

                    <span v-else
                          class="tm-item-card-price-wholesale uk-text-baseline">
                    {{ ProductPrice.ShopItemPrice.calculated_price }}&nbsp;{{ ProductPrice.ShopCurrency.name }}
                    <span v-if="ProductPrice.ShopItemPriceType.description"
                          :title="ProductPrice.ShopItemPriceType.description"
                          uk-icon="icon: question"
                          class="uk-icon tm-item-card-price-wholesale-icon"
                          uk-tooltip></span>
                </span>

                </div>
            </div>

        </div>

        <div v-if="hasQuantity === true" class="uk-width-1-1 uk-margin-small-top" style="padding: 0;">
            <div class="uk-width-1-1 tw-warehouse-quantity">
                <div>В наличии на складе</div>
            </div>
        </div>

        <!-- Add to cart -->
        <div v-show="!inCart" class="uk-width-1-1 uk-grid-small uk-margin-small-top" uk-grid>

            <div>
                <input v-model.number="quantity" class="uk-input uk- uk-text-center"
                       style="width: 60px;">
            </div>

            <div class="uk-width-expand">
                <button :disabled="!canBuy"
                        @click="$emit('buy-shop-item',quantity,ShopItem)"
                        class="uk-button uk-button-secondary uk-width-1-1">
                    <span> Заказать</span>
                </button>
            </div>

        </div>
        <div  v-show="inCart" class="uk-width-1-1 uk-grid-small uk-margin-small-top" uk-grid>
            <div class="uk-width-expand">
                <a href="/cart"
                   class="uk-button uk-button-secondary uk-width-1-1">
                    <span>В корзине: {{ quantityInCart }} шт.</span>
                </a>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        props: {
            ShopItem: {
                type: Object,
                required: true
            },
            ShopOrderItem: {
                type: Object,
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemPrices: {
                'type': Array,
                'default': []
            }
        },
        data() {
            return {
                quantity: 1,
                loading: false,
            }
        },
        computed: {
            canBuy() {
                return Number.isInteger(this.quantity) && this.quantity > 0;
            },
            inCart() {
                return !!this.ShopOrderItem.shop_item_id;
            },
            hasQuantity() {
                return this.ShopItemWarehouses.some((warehouse) => {
                    return warehouse.quantity > 0
                })
            },
            quantityInCart(){
                if(!!this.ShopOrderItem.shop_item_id){
                    return this.ShopOrderItem.quantity
                }
            }

        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// ShopItemPrices.vue?e88513bc